import { AuthAPI, MpxResponseError } from '@cibo/core'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'

import { QUERY_KEY } from './queryKey'

export const AUTH_FORM_TOKEN_TIMEOUT = 14 * 60 * 1000

export interface AuthFormToken {
  formAuthToken: string
  captchaData: {
    formAuthCode: string
  }
}

export const useFormToken = () => {
  const queryClient = useQueryClient()
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const queryStringFormAuthToken = params.get('formAuthToken')

  const query = useQuery<AuthFormToken, Error | MpxResponseError>({
    queryKey: [QUERY_KEY.FORM_TOKEN],
    queryFn: async () => {
      const response = await AuthAPI.createFormToken()

      return response && response.data
    },

    staleTime: AUTH_FORM_TOKEN_TIMEOUT,
    refetchInterval: AUTH_FORM_TOKEN_TIMEOUT,
    refetchIntervalInBackground: true,
  })

  return {
    ...query,
    formAuthToken: queryStringFormAuthToken || query.data?.formAuthToken,
    formAuthCode: query.data?.captchaData?.formAuthCode,
    updateFormToken: (formAuthToken: string) => {
      queryClient.cancelQueries({ queryKey: [QUERY_KEY] })
      queryClient.setQueryData([QUERY_KEY.FORM_TOKEN], {
        formAuthToken,
        captchaData: { formAuthCode: '' },
      })
    },
    expireFormToken: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEY] }),
  }
}

export const useExpireAuthFormToken = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
}
